import { TourBoasVindasService } from '@services';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import {
  verificaTourBoasVindasSuccess,
  insereRegistroBoasVindasSuccess,
  verificaRegistroBoasVindasError,
  insereRegistroBoasVindasError,
} from './actions';

function* verificaRegistroBoasVindas(values) {
  const service = new TourBoasVindasService();
  const user = yield select((state) => state.user);
  if (user.id === user.matricula) {
    const registroBoasVindas = yield call(
      service.getVerificaTourBoasVindas,
      values
    );
    try {
      const responseRegistro = registroBoasVindas.data[0];
      yield put(verificaTourBoasVindasSuccess(responseRegistro));
    } catch (p) {
      const errorMsg = `Ocorreu um erro ao verificar o Tour${p}`;
      yield put(verificaRegistroBoasVindasError(errorMsg));
    }
  }
}

function* insereRegistoBoasVindas(matricula, etapa) {
  const service = new TourBoasVindasService();
  const registroBoasVindas = yield call(
    service.setInsereRegistroBoasVindas,
    matricula,
    etapa
  );

  try {
    const responseRegistro = registroBoasVindas.data[0].linhasafetadas;
    if (responseRegistro !== 0) {
      yield put(insereRegistroBoasVindasSuccess(responseRegistro));
    } else {
      const errorMsg =
        'Ocorreu um erro ao inseir registros no Tour: Linhas afetadas: 0';
      yield put(insereRegistroBoasVindasError(errorMsg));
    }
  } catch (p) {
    const errorMsg = `Ocorreu um erro ao inseir registros no Tour: ${p}`;
    yield put(insereRegistroBoasVindasError(errorMsg));
  }
}

export default all([
  takeLatest('VERIFICA_BOASVINDAS_REQUEST', verificaRegistroBoasVindas),
  takeLatest('INSERE_BOASVINDAS_REQUEST', insereRegistoBoasVindas),
]);
